import { STAFFS } from "../../types/UserType";
import axios from "axios";

const getStaff = (data) => {
	return {
		type: STAFFS,
		payload: data,
	};
};

export const loadAllStaff = ({ status } = {}) => {
	//dispatching with an call back function and returning that
	return async (dispatch) => {
		try {
			const statusParam = status !== undefined ? status : true;
			const { data } = await axios.get(`user?status=${statusParam}`);
			//dispatching data
			dispatch(getStaff(data));
		} catch (error) {
			console.log(error.message);
		}
	};
};
